/* Sheepskinhouse: fold long text blocks (collection descriptions, SEO copy) behind a "read more" toggle.
   Usage: add data-ssh-fold[="<maxpx>"] to a block. Labels from window.SSH_FOLD = {more, less}. */
(function () {
  var L = window.SSH_FOLD || { more: 'Read more', less: 'Show less' };
  function init(el) {
    if (el.__sshFold) return; el.__sshFold = 1;
    var max = parseInt(el.getAttribute('data-ssh-fold') || '', 10) || 96;
    if (el.scrollHeight <= max + 24) return;
    el.classList.add('ssh-fold', 'is-clamped');
    el.style.setProperty('--ssh-fold-max', max + 'px');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ssh-fold__btn'; btn.textContent = L.more; btn.setAttribute('aria-expanded', 'false');
    el.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-clamped') === false;
      btn.textContent = open ? L.less : L.more; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) el.scrollIntoView({ block: 'nearest' });
    });
  }
  function scan() { document.querySelectorAll('[data-ssh-fold]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  var css = document.createElement('style');
  css.textContent = '.ssh-fold.is-clamped{max-height:var(--ssh-fold-max,96px);overflow:hidden;position:relative;-webkit-mask-image:linear-gradient(#000 55%,transparent);mask-image:linear-gradient(#000 55%,transparent)}' +
    '.ssh-fold__btn{display:inline-block;margin:.6rem 0 0;padding:0;background:none;border:0;font:inherit;font-size:1.3rem;font-weight:600;text-decoration:underline;text-underline-offset:.25em;cursor:pointer;color:inherit}';
  document.head.appendChild(css);
})();
